import React, {Component} from 'react';
import PropTypes from 'prop-types';
import de from 'date-fns/locale/de';
import { withTranslation } from 'react-i18next';
import DatePicker, {registerLocale, setDefaultLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TicketForm from './ticket-form';
import {connect} from 'react-redux';
import SponsoredDay from '../../../sponsored-day';
import EventDay from '../../../event-day';
import {secondsToHoursAndMinutes} from '../../../../calendar/calendar-context.js';

registerLocale('de', de);
setDefaultLocale('de', de);

const mapStateToProps = state => ({
  mobile: state.appStore.mobile,
});

class CalendarExtend extends Component {

  constructor(props) {
    super(props);

    const unikatumCalendar = window.unikatum_calendar;

    const today = new Date(),
      closedDays = [],
      noOnlineTicketsDays = [],
      weekdays = [],
      weekendDays = [],
      holidays = [],
      summerMuseumDays = [],
      specialOpeningDays = [];

    unikatumCalendar.days.all.entities.forEach(day => {
      if (day?.fieldNoOnlineTickets === true) {
        noOnlineTicketsDays.push(day.fieldDatumTag.value);
      }
    })

    unikatumCalendar.days.closed.entities.forEach(day => {
      closedDays.push(day.fieldDatumTag.value);
    })
    unikatumCalendar.days.weekdays.entities.forEach(day => {
      weekdays.push(day.fieldDatumTag.value);
    })
    unikatumCalendar.days.weekends.entities.forEach(day => {
      weekendDays.push(day.fieldDatumTag.value);
    })
    unikatumCalendar.days.holidays.entities.forEach(day => {
      holidays.push(day.fieldDatumTag.value);
    })
    unikatumCalendar.days.summer_museum.entities.forEach(day => {
      summerMuseumDays.push(day.fieldDatumTag.value);
    })
    unikatumCalendar.days.special_opening.entities.forEach(day => {
      specialOpeningDays.push(day.fieldDatumTag.value);
    })

    let lastDayOfCalendar = new Date();
    lastDayOfCalendar.setMonth(today.getMonth() + 12);
    lastDayOfCalendar.setDate(0);

    this.state = {
      today: today,
      lastDayOfCalendar: lastDayOfCalendar,
      selectedDay: today,
      closedDays: closedDays,
      noOnlineTicketsDays: noOnlineTicketsDays,
      weekdays: weekdays,
      weekendDays: weekendDays,
      holidays: holidays,
      summerMuseumDays: summerMuseumDays,
      specialOpeningDays: specialOpeningDays,
      unikatumCalendar: unikatumCalendar,
      dayTypeWeekday: unikatumCalendar.day_types.weekdays,
      dayTypeWeekend: unikatumCalendar.day_types.weekends,
      dayTypeHoliday: unikatumCalendar.day_types.holidays,
      dayTypeSummerMuseum: unikatumCalendar.day_types.summer_museum,
      dayTypeSpecialOpening: unikatumCalendar.day_types.special_opening,
    }
  }

  handleDateChange = date => {
    this.setState({selectedDay: date});
  }

  render() {
    const renderDays = (day, date) => {
      // Add 12 hours as a workaround, otherwise toISOString returns the day before (-1 hour) due to the timezone.
      date.setHours(12)
      // Get date string in "YYYY-MM-DD" format for easier comparisons.
      let dateString = date.toISOString().substring(0, 10)

      // Gather day information and pass it as a class to HTML element.
      let classes = 'date';

      // Check if "Kalenderpate" (sponsor) exists for the day => just add a little icon.
      let sponsorship = false;
      this.state.unikatumCalendar.days.sponsors.entities.some(day => {
        day.fieldDateFuture.some(date => {
          if (date.value === dateString) {
            classes += ' sponsorship';
            sponsorship = true;
          }
        })
      })

      // Check if "keine Online-Tickets".
      if (this.state.noOnlineTicketsDays.includes(dateString)) {
        classes += ' no-online-tickets';
      } else if (this.state.closedDays.includes(dateString)) {
        classes += ' closed';
      } else if (this.state.summerMuseumDays.includes(dateString)) {
        classes += ' museum-summer';
      } else if (this.state.specialOpeningDays.includes(dateString)) {
          classes += ' special-opening';
      } else if (this.state.weekendDays.includes(dateString)) {
        classes += ' weekend';
      } else if (this.state.holidays.includes(dateString)) {
        classes += ' holiday';
      }

      return renderDay(day, classes, sponsorship);
    }

    // Generic function to render one day for the date picker.
    function renderDay(date, classes, sponsorship) {
      return(
        <div className={classes}>
          {date}
          {sponsorship &&
            <img src="/themes/custom/module_box/src/images/Kalenderpaten.svg" alt=""/>
          }
        </div>
      )
    }

    return (
      <>
        <div className="calender-extend">
          <div className="container pt-5 pb-3">
            <div className="row align-items-end">
              <div className="col-12 col-lg-3 py-3">
                <div className="text-stretched mb-3">
                  <strong>{this.props.t('Unsere Öffnungszeiten')}:</strong>
                </div>
                <div className="opening-hours">
                  {!!this.state.dayTypeWeekday &&
                    <div className="opening">
                      <div className="icon">
                        <div className="icon-container" />
                      </div>
                      <div className="opening-hours-wrapper">
                        <span className="bold">{this.props.t('Werktage')}</span>
                        <span>{secondsToHoursAndMinutes(this.state.dayTypeWeekday?.entities[0]?.fieldOpeningHours?.from)} - {secondsToHoursAndMinutes(this.state.dayTypeWeekday?.entities[0]?.fieldOpeningHours?.to)}</span>
                      </div>
                    </div>
                  }
                  {!!this.state.dayTypeWeekend &&
                    <div className="opening weekend">
                      <div className="icon">
                        <div className="icon-container" />
                      </div>
                      <div className="opening-hours-wrapper">
                        <span className="bold">{this.props.t('Wochenende')}</span>
                        <span>{secondsToHoursAndMinutes(this.state.dayTypeWeekend?.entities[0]?.fieldOpeningHours?.from)} - {secondsToHoursAndMinutes(this.state.dayTypeWeekend?.entities[0]?.fieldOpeningHours?.to)}</span>
                      </div>
                    </div>
                  }
                  {!!this.state.dayTypeHoliday &&
                    <div className="opening holiday">
                      <div className="icon">
                        <div className="icon-container" />
                      </div>
                      <div className="opening-hours-wrapper">
                        <span className="bold">{this.props.t('Ferien & Feiertage')}</span>
                        <span>{secondsToHoursAndMinutes(this.state.dayTypeHoliday?.entities[0]?.fieldOpeningHours?.from)} - {secondsToHoursAndMinutes(this.state.dayTypeHoliday?.entities[0]?.fieldOpeningHours?.to)}</span>
                      </div>
                    </div>
                  }
                  {!!this.state.dayTypeSummerMuseum &&
                    <div className="opening museum-summer">
                      <div className="icon">
                        <div className="icon-container" />
                      </div>
                      <div className="opening-hours-wrapper">
                        <span className="bold">{this.props.t('Sommer-Museum')}</span>
                        <span>{secondsToHoursAndMinutes(this.state.dayTypeSummerMuseum?.entities[0]?.fieldOpeningHours?.from)} - {secondsToHoursAndMinutes(this.state.dayTypeSummerMuseum?.entities[0]?.fieldOpeningHours?.to)}</span>
                      </div>
                    </div>
                  }
                  {!!this.state.dayTypeSpecialOpening &&
                    <div className="opening special-opening">
                      <div className="icon">
                        <div className="icon-container" />
                      </div>
                      <div className="opening-hours-wrapper">
                        <span className="bold">{this.props.t('Spezial-Öffnung')}</span>
                        <span>{secondsToHoursAndMinutes(this.state.dayTypeSpecialOpening?.entities[0]?.fieldOpeningHours?.from)} - {secondsToHoursAndMinutes(this.state.dayTypeSpecialOpening?.entities[0]?.fieldOpeningHours?.to)}</span>
                      </div>
                    </div>
                  }
                  <div className="opening no-online-tickets">
                    <div className="icon">
                      <div className="icon-container" />
                    </div>
                    <div className="opening-hours-wrapper">
                      <span className="bold">{this.props.t('Online-Tickets ausverkauft')}</span>
                    </div>
                  </div>
                  <div className="opening closed">
                    <div className="icon">
                      <div className="icon-container" />
                    </div>
                    <div className="opening-hours-wrapper">
                      <span className="bold">{this.props.t('Geschlossen')}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 py-3 text-center">
                <DatePicker
                  locale={this.props.i18n.language}
                  selected={this.state.selectedDay}
                  onChange={date => this.handleDateChange(date)}
                  dateFormat={'dd.MM.yyyy'}
                  minDate={new Date(this.state.today.getFullYear(), this.state.today.getMonth(), 1)}
                  maxDate={this.state.lastDayOfCalendar}
                  renderDayContents={renderDays}
                  inline
                  calendarStartDay={1}
                />
                <div className="d-lg-none">
                  <EventDay date={this.state.selectedDay} />
                </div>
                <div className="d-lg-none">
                  <TicketForm selectedDay={this.state.selectedDay} />
                </div>
              </div>
              <div className="col-12 col-lg-3 py-3">
                <div className="calender-information">
                  <div className="info-text">
                    <div className="mb-3">
                      <strong>{this.props.t('Außerhalb der Öffnungszeiten')}:</strong>
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: window.calendarParagraphLegendClosedHours }}></div>
                  </div>
                  <div className="sponsorship">
                    <div className="sponsorship-info mb-3">
                      <span className="icon">
                        <img src="/themes/custom/module_box/src/images/Kalenderpaten.svg" alt=""/>
                      </span>
                      <span>{this.props.t('Kalenderpatenschaft')}</span>
                    </div>
                    <div className="sponsorship-text">
                      <SponsoredDay date={this.state.selectedDay} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-none d-lg-block">
            <EventDay date={this.state.selectedDay} />
          </div>
          <div className="container py-3 d-none d-lg-block">
            <div className="row">
              <div className="col-12 col-lg-4 offset-lg-4">
                <TicketForm selectedDay={this.state.selectedDay} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps)(withTranslation()(CalendarExtend));
